<template>
  <div class="space-ba-xxl" id="einleitung">
    <h1 class="space-ba-xl" v-html="newLineText(entries.titel)"></h1>
    <div class="body-text" v-html="newLineText(entries.einleitungStartseite)"></div>
  </div>
</template>

<script>

export default {
  name: "Einleitung",
  props: {
    entries: Object,
  },
  data() {
    return {};
  },
  methods: {
    newLineText(el) {
      if (el) {
        return el.replace(/(?:\r\n|\r|\n)/g, "<br />");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  padding-top: 0.8rem
}

@media (min-width: 768px) {
  h1 {
    padding-top: 2.65rem
  }
}
</style>

